import Vue from "vue";

// 引入所有需要注册的全局组件
import Button from "@/components/newComponents/Button/index.vue";
import Dialog from "@/components/newComponents/Dialog/index.vue";
import Tip from "@/components/newComponents/Tip/index.vue";
import Title from "@/components/newComponents/Title/index.vue";
import Table from "@/components/newComponents/Table/index.vue";
import Image from "@/components/newComponents/Image/index.vue";
import Loading from "@/components/newComponents/Loading/jd-loading.vue";
import LodingNew from "@/components/newComponents/Loading/jd-loading-new.vue";
import DataSelect from "@/components/newComponents/DataSelect/index.vue";
import Form from "@/components/newComponents/Form/index.vue";
import StatusTable from "@/components/newComponents/StatusTable/index.vue";
import subPageTitle from "@/components/newComponents/subPageTitle/index.vue";
import Tab from "@/components/newComponents/Tab/index.vue";
import BackAction from "@/components/newComponents/BackAction/index.vue";
import select from "@/components/newComponents/select/index.vue";
// import BackAction from "@/components/newComponents/BackAction/index.vue";
// import previewMobilePhone from "@/components/newComponents/previewPhone/index.vue";
// import select from "@/components/newComponents/select/index.vue";
// import status from "@/components/newComponents/status/index.vue";
import Radio from "@/components/newComponents/Radio/index.vue";
//定义一个数组结构
const components = [
  { name: "jdButton", component: Button },
  { name: "jdDialog", component: Dialog },
  { name: "jdTip", component: Tip },
  { name: "jdTitle", component: Title },
  { name: "jdDataSelect", component: DataSelect },
  { name: "jdSubPageTitle", component: subPageTitle },
  { name: "jdTable", component: Table },
  { name: "jdForm", component: Form },
  { name: "jdTab", component: Tab },
  { name: "jdImage", component: Image },
  { name: "jdLoading", component: Loading },
  { name: "jdLoadingNew", component: LodingNew },
  // { name: "tbBackAction", component: BackAction },
  // { name: "previewMobilePhone", component: previewMobilePhone },
  // { name: "tbSelect", component: select },
  // { name: "tbStatus", component: status },
  { name: "jdBack", component: BackAction },
  { name: "jdSelect", component: select },
  { name: "jdRadio", component: Radio },
  { name: "jdStatus", component: StatusTable },
];
//遍历数组进行循环注册
components.forEach((component) => {
  Vue.component(component.name, component.component);
});
